import { createFileRoute } from "@tanstack/react-router";
import { CohortsScreen } from "@modules/cohorts/views";

export const Route = createFileRoute("/_staff-area/cohorts/")({
  staticData: { title: "nav.cohorts" },
  component: CohortsScreen,
});
